import { useState } from "react";
import { Send, Sparkles } from "lucide-react";
import { FAITHS, PROMPTS } from "@/lib/faiths";

export const QuestionComposer = ({
  onSubmit,
  loading,
  faith,
  setFaith,
  question,
  setQuestion,
  compact = false,
}) => {
  const submit = (e) => {
    e?.preventDefault();
    if (!question.trim() || loading) return;
    onSubmit(question.trim());
  };

  return (
    <div className="w-full">
      {/* Faith chips */}
      <div className="flex items-center gap-2 flex-wrap mb-4">
        <span className="text-xs sm:text-[0.72rem] uppercase tracking-[0.18em] text-[#FBEBD3] font-sans-clean font-bold mr-1">
          Sources
        </span>
        {FAITHS.map((f) => {
          const active = faith === f.id;
          return (
            <button
              key={f.id}
              data-testid={`faith-chip-${f.id}`}
              onClick={() => setFaith(f.id)}
              className={`text-lg sm:text-[0.85rem] uppercase tracking-[0.1em] font-sans-clean font-bold px-4 py-2.5 rounded-full transition-all border-2 ${
                active
                  ? "bg-[#FFFFFF] text-[#5C0E1D] border-[#FFFFFF]"
                  : "bg-transparent text-[#FFFFFF] border-[#E7B04A]/60 hover:border-[#E7B04A] hover:text-[#E7B04A] hover:bg-[#E7B04A]/10"
              }`}
            >
              {f.short}
            </button>
          );
        })}
      </div>

      <form onSubmit={submit} className="relative">
        <textarea
          data-testid="question-input-textarea"
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              submit(e);
            }
          }}
          placeholder={compact ? "Ask another question…" : "What is troubling your heart today?"}
          rows={compact ? 2 : 3}
          className="w-full resize-none rounded-2xl bg-[#4A0A17]/70 gold-border px-5 py-4 pr-14 text-2xl sm:text-xl font-scripture text-[#FFFFFF] placeholder:text-[#FBEBD3] placeholder:italic focus:outline-none focus:ring-2 focus:ring-[#E7B04A]/50 transition-all"
        />
        <button
          type="submit"
          data-testid="submit-question-btn"
          disabled={loading || !question.trim()}
          aria-label="Ask"
          className="absolute right-3 bottom-3 inline-flex items-center justify-center rounded-full w-12 h-12 bg-[#E7B04A] text-[#5C0E1D] hover:bg-[#F5C76B] disabled:opacity-40 disabled:cursor-not-allowed transition-all shadow-md"
        >
          {loading ? (
            <Sparkles className="w-5 h-5 animate-pulse" />
          ) : (
            <Send className="w-5 h-5" strokeWidth={1.8} />
          )}
        </button>
      </form>

      {!compact && (
        <div className="mt-4 flex items-center gap-2 flex-wrap">
          <span className="text-xs sm:text-[0.72rem] uppercase tracking-[0.18em] text-[#FBEBD3] font-sans-clean font-bold mr-1">
            Try
          </span>
          {PROMPTS.map((p) => (
            <button
              key={p.key}
              data-testid={`prompt-chip-${p.key}`}
              onClick={() => setQuestion(p.q)}
              className="text-lg sm:text-sm font-scripture italic px-4 py-2.5 rounded-full text-[#FFFFFF] bg-[#4A0A17]/70 border border-[#E7B04A]/40 hover:text-[#E7B04A] hover:border-[#E7B04A] hover:bg-[#4A0A17] transition-colors"
            >
              {p.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default QuestionComposer;
